import React, { memo, useCallback } from 'react';
import ConnectionFailed from 'design-system/ConnectionFailed';
import useFetch from 'hooks/useFetch';
import { getPotsAccount } from '../actions';
const ConnectionFailedView = () => {
    const [, , fetching, fetch] = useFetch({
        muteError: true,
        muteResult: true,
        muteFetching: false,
    });
    const handleTryAgain = useCallback(() => {
        fetch(getPotsAccount());
    }, []);
    return <ConnectionFailed handleTryAgain={handleTryAgain} requesting={fetching}/>;
};
export default memo(ConnectionFailedView);
